// Mirrors CodeEngine.Common.Objects.Enums.DigitalAssetType.
// The API serializes this enum as a NUMBER on vaults (vaultType) and currencies
// (assetType), but as the enum NAME string in phaseEligibility.digitalAssetTypeId
// (built via VaultType.ToString() in VaultingLogic).
export const DigitalAssetTypes = Object.freeze({
  BITCOIN: 0,
  ETHEREUM: 1,
  USDC: 2,
  XRP: 3,
  XPR: 4,
  LITECOIN: 5,
  TETHER: 6,
  XMD: 7,
  XPR_TOKEN: 8,
  CARDANO: 9,
  SOLANA: 10,
  TRON: 11
});

// Numeric value -> backend enum name, for joining against phaseEligibility.
export const DigitalAssetTypeNames = Object.freeze({
  0: 'Bitcoin',
  1: 'Ethereum',
  2: 'Usdc',
  3: 'XRP',
  4: 'XPR',
  5: 'Litecoin',
  6: 'Tether',
  7: 'XMD',
  8: 'XprToken',
  9: 'Cardano',
  10: 'Solana',
  11: 'Tron'
});
